import { type ReactNode } from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function HeroIcon(): ReactNode {
  return (
    <div className="relative mx-auto flex size-16 items-center justify-center">
      <div
        aria-hidden
        className="absolute inset-0 rounded-full bg-brand-red/25 blur-2xl"
      />
      <div className="relative flex size-16 items-center justify-center rounded-full bg-brand-red/15 ring-1 ring-brand-red/50">
        <Check size={30} strokeWidth={2.5} className="text-brand-red" />
      </div>
    </div>
  );
}

type ActionProps = { waLink: string; onDismiss: () => void };

export function PopupActions({ waLink, onDismiss }: ActionProps): ReactNode {
  const handleClick = (): void => {
    if (waLink) window.open(waLink, '_blank', 'noopener,noreferrer');
    onDismiss();
  };
  return (
    <Button
      variant="primary"
      size="lg"
      onClick={handleClick}
      className="group w-full shadow-[0_8px_28px_-8px_rgba(255,68,68,0.6)]"
    >
      ¡A jugarla!
      <ArrowRight
        size={18}
        strokeWidth={2.25}
        className="ml-2 transition-transform group-hover:translate-x-0.5"
      />
    </Button>
  );
}

export function PopupBody({ waLink, onDismiss }: ActionProps): ReactNode {
  return (
    <div className="flex flex-col items-center gap-lg pb-sm pt-xs text-center">
      <HeroIcon />
      <div className="flex flex-col gap-xs">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-brand-coral">
          Prueba superada
        </p>
        <h2 className="font-display text-3xl font-bold leading-tight text-text-primary sm:text-4xl">
          <span className="block">Bienvenido a</span>
          <span className="block text-brand-red">The 3333 Games</span>
        </h2>
      </div>
      <PopupActions waLink={waLink} onDismiss={onDismiss} />
    </div>
  );
}
